import { useCallback, useEffect, useRef, useState } from 'react';

import DefectenLijst from '@/components/sidebar/defecten/DefectenLijst';
import useSidebarStore from '@/components/sidebar/hooks/useSidebarStore';
import useApiErrorStatus from '@/hooks/useApiErrorStatus';
import { useGetDefecten } from '@/queries/defecten/useGetDefecten';
import useDefecten from '@/state/selectors/useDefecten';
import useClientState from '@/state/useClientState';

import PanelHeader from '../stickyPanelHeader/PanelHeader';

import { DefectenFilterDialog } from './defectenFilter/DefectenFilterDialog';
import { defaultFilter } from './defectenFilter/defectenFilterModel';

import styles from './Defecten.module.css';

const useSyncDefectenUitBackendMetClientState = () => {
  const defectenRefreshVersion = useSidebarStore((s) => s.defectenRefreshVersion);
  const { data, isError, errorUpdateCount, isSuccess } = useGetDefecten(undefined, 30_000);
  const { refetch } = useGetDefecten();
  const { handleApiStatus } = useApiErrorStatus();
  const vervangAlleDefecten = useClientState((state) => state.vervangAlleDefecten);

  const lastFetchRef = useRef<number>(0);
  const firstEventRef = useRef(true);

  useEffect(() => {
    if (data) {
      vervangAlleDefecten(data);
    }
  }, [data, vervangAlleDefecten]);

  useEffect(() => {
    handleApiStatus('alleDefecten', isError && !isSuccess);
  }, [isError, isSuccess, errorUpdateCount]);

  useEffect(() => {
    const now = Date.now();
    if (firstEventRef.current) {
      void refetch();
      lastFetchRef.current = now;
      firstEventRef.current = false;
    } else if (now - lastFetchRef.current > 500) {
      void refetch();
      lastFetchRef.current = now;
    }
  }, [defectenRefreshVersion, refetch]);
};

function Defecten({ panelMenuInformation }) {
  useSyncDefectenUitBackendMetClientState();

  const { defectenView: alleDefecten } = useDefecten();

  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const currentFilter = useSidebarStore((state) => state.defectenFilter);
  const setCurrentFilter = useSidebarStore((state) => state.setDefectenFilter);

  const handleShowFilterDialog = useCallback((value: boolean) => {
    setShowFilterDialog(value);
  }, []);

  return (
    <div className={styles.defectenStyle}>
      <PanelHeader
        title='Defecten'
        sectionId='defecten'
        onFilterMenuItemClick={() => setShowFilterDialog(true)}
        filterActive={currentFilter !== defaultFilter}
      />
      <DefectenLijst defecten={alleDefecten ?? []} filter={currentFilter} panelMenuInformation={panelMenuInformation} />
      {showFilterDialog && (
        <DefectenFilterDialog
          showDialog={showFilterDialog}
          handleOpenChange={handleShowFilterDialog}
          huidigFilter={currentFilter}
          setNieuwFilter={setCurrentFilter}
        />
      )}
    </div>
  );
}

export default Defecten;
